import type { PublicBusinessConfig } from '@kizen/api/business';
import {
  type BusinessQueries,
  defBusinessQueries,
} from '@kizen/query/business';
import AxiosService from '__services/AxiosService';

type Option = {
  value: string;
  label: string;
};

const queries: BusinessQueries = defBusinessQueries(AxiosService);

export const publicBusinessConfigQuery: BusinessQueries['publicBusinessConfigQuery'] =
  queries.publicBusinessConfigQuery;

export const selectPhoneRegionOptions = (
  data: PublicBusinessConfig
): Option[] => {
  return data.phone_regions.reduce<Option[]>((acc, [code, label]) => {
    acc.push({ value: code, label });
    return acc;
  }, []);
};

export const selectTimezoneOptions = (data: PublicBusinessConfig): Option[] => {
  return data.timezones
    .map(([value, label]) => {
      return { value, label };
    })
    .sort((a, b) => {
      return a.label > b.label ? 1 : -1;
    });
};
